<template>
  <!--
    Temporary local override of RevContainer for the `plpWideContainer` A/B test (SR-5740).
    When the experiment concludes:
    - winner = noVariation       → delete this file, restore @ds/components/Container RevContainer
    - winner = withWideContainer → upstream the wider max-width into RevContainer (DS ticket DSB-10343)
  -->
  <div class="flex justify-center">
    <div
      :class="[
        'max-w-full grow px-24 lg:max-w-[1184px] lg:basis-full lg:px-32',
        isWide && 'xl:max-w-[1618px]',
      ]"
      data-test="plp-container-wrapper"
    >
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  isWide?: boolean
}>()
</script>
